import {Workout, WorkoutMinimal} from "myfitworld-model";

export const getWorkoutExercisesCount = (item: Workout, exercises_text: string, exercise_text: string): string => {
  const exercises =
    (item?.coolDownGroup?.exercises?.length || 0) +
    (item?.warmUpGroup?.exercises?.length || 0) +
    (item?.exerciseGroups?.reduce((acc, group) => acc + (group?.exercises.length || 0), 0) || 0);
  return `${exercises} ${exercises === 1 ? exercise_text : exercises_text}`;
};

export const getWorkoutMinimalExercisesCount = (item: WorkoutMinimal): number => {
  const exercises =
    (item?.coolDownGroup?.exercises?.length || 0) +
    (item?.warmUpGroup?.exercises?.length || 0) +
    (item?.exerciseGroups?.reduce((acc, group) => acc + (group?.exercises.length || 0), 0) || 0);
  return exercises;
};

